// @ flow
import React from "react"

const ZoomIn = () => {
  return (
    <svg
      className="Scooter-zoomIcon_in iconPath"
      x="0px"
      y="0px"
      viewBox="0 0 512 512"
      enableBackground="new 0 0 512 512">
      <g>
        <g>
          <path
            className="iconPath"
            d="M506.141,477.851L361.689,333.399c65.814-80.075,		61.336-198.944-13.451-273.73c-79.559-79.559-209.01-79.559-288.569,0
						s-79.559,209.01,0,288.569c74.766,74.766,193.62,79.293,273.73,13.451l144.452,144.452c7.812,7.812,20.477,7.812,28.289,0
					C513.953,498.328,513.953,485.663,506.141,477.851z M319.949,319.948c-63.96,63.96-168.03,63.959-231.99,0
					c-63.96-63.96-63.96-168.03,0-231.99c63.958-63.957,168.028-63.962,231.99,0C383.909,151.918,383.909,255.988,319.949,319.948z"
          />
        </g>
      </g>
      <g>
        <g>
          <path
            className="iconPath"
            d="M301.897,183.949h-77.94v-77.94c0-11.048-8.956-20.004-20.004-20.004c-11.048,0-20.004,8.956-20.004,20.004v77.94h-77.94
						c-11.048,0-20.004,8.956-20.004,20.004c0,11.048,8.956,20.004,20.004,20.004h77.94v77.94c0,11.048,8.956,20.004,20.004,20.004
					c11.048,0,20.004-8.956,20.004-20.004v-77.94h77.94c11.048,0,20.004-8.956,20.004-20.004
					C321.901,192.905,312.945,183.949,301.897,183.949z"
          />
        </g>
      </g>
    </svg>
  )
}

export default ZoomIn
